import React, { useContext, useEffect, useState, useMemo } from "react";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import axios from "axios";
import { ethers } from "ethers";

function ClaimModal() {
  const {
    copyaddress,
    account,
    toastSuccess,
    dbuser,
    formatAddress,
    toastError,
    settings,
    Refaddress,
    getuserDB,
    x2balance,
    dbbalance,
    getsmcs,
    Maincontract,
    Usdtcontract,
    useractivestatus,
    DefinRate,
    rateContract,
    wfee, Wcontract,Wcontract2, ClaimLimit,
  } = useContext(ProjectContext);

  const [amount, setAmount] = useState("");
  const [trdone, setTrdone] = useState(false);
  const [hash, setHash] = useState("");
  const [loading, setLoading] = useState(false);
  const [rcv_amount, setrcv_amount] = useState(0);
  const [settled, setsettled] = useState(false);
  const [fees, setfees] = useState(0);
  const [total_tokens, settotal_tokens] = useState(0);
  const [RUsdt, setRUsdt] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  const { openConnectModal } = useConnectModal();
  const navigate = useNavigate();

  const arbProvider = new ethers.providers.JsonRpcProvider("https://arb1.arbitrum.io/rpc");

  // // Safely create the rate contract only if ABI and address are valid
  // const rateContract = useMemo(() => {
  //   if (!settings?.ratecontract || !Array.isArray(settings?.ratecontract_abi)) {
  //     console.warn("Rate contract ABI or address not found.");
  //     return null;
  //   }
  //   return new ethers.Contract(settings.ratecontract, settings.ratecontract_abi, arbProvider);
  // }, [settings]);

    const getuserData = async () => {
      await axios
        .post(process.env.REACT_APP_BACKEND_LINK, {
          method: "user",
          submethod: "getbyid",
          username: account,
          key: process.env.REACT_APP_KEY,
        })
        .then((res) => {
          if (res.data.error) {
            return "";
          }
          if(res.data.data.isSettled == true)
          {
            setsettled(true);
          }
          console.log("NEW API",res.data, res.data.data.isSettled);
        });
    };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    
    setErrorMessage('');
    
    setrcv_amount()
    setRUsdt()
    setfees()
    
    setAmount(e.target.value);
    
    if (value && parseFloat(value) > ClaimLimit) {
      setErrorMessage(`Amount must be less then or equal $ ${ClaimLimit}`);
      setAmount(0);
    }
    
    // fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    
    try {
      console.log("1log", amount);
      const parsedAmount = ethers.utils.parseUnits(amount.toString(), 18);
      console.log("1log", parsedAmount.toString());
      
      const tmtUST = (parseFloat(amount) * wfee) / 100;
      console.log("1log", tmtUST);
      const tmtUSTParsed = ethers.utils.parseUnits(tmtUST.toString(), 18);
      console.log("1log", tmtUSTParsed.toString());
      const tmtfee = await rateContract.calculatetoken(tmtUSTParsed);
      console.log("2log", tmtfee.toString());
      const rcvAmountRaw = await rateContract.calculatetoken(
        ethers.utils.parseUnits((parseFloat(amount) - tmtUST).toString(), 18)
      );
      console.log("2log", rcvAmountRaw);
      setRUsdt(parseFloat(amount) - tmtUST);
      settotal_tokens(tmtUST);
      setfees(ethers.utils.formatEther(tmtfee.toString()));
      setrcv_amount(Number(ethers.utils.formatEther(rcvAmountRaw.toString())));
    } catch (error) {
      console.error("Error calculating token values:", error);
      toastError("Error calculating token values");
    }
    setLoading(false);
  };

  const withdrawal = async () => {
    setTrdone(true);
    setHash("");
    setLoading(true);

    if (!account) {
      openConnectModal();
      toastError("Connect first");
      setTrdone(false);
      setLoading(false);
      return;
    }

    if (dbbalance < 0) {
      toastError("Insufficient Balance");
      setTrdone(false);
      setLoading(false);
      return;
    }

    try {
      
      const parsedAmount = ethers.utils.parseUnits(amount.toString(), 18);
      console.log("1log", parsedAmount.toString());
      
      const tmtUST = (parseFloat(amount) * wfee) / 100;
      console.log("1log", tmtUST);
      const tmtUSTParsed = ethers.utils.parseUnits(tmtUST.toString(), 18);
      console.log("1log", tmtUSTParsed.toString());
      const tmtfee = await rateContract.calculatetoken(tmtUSTParsed);
      console.log("2log", tmtfee.toString());
      const rcvAmountRaw = await rateContract.calculatetoken(
        ethers.utils.parseUnits((parseFloat(amount) - tmtUST).toString(), 18)
      );
      console.log("2log", rcvAmountRaw);
      setRUsdt(parseFloat(amount) - tmtUST);
      settotal_tokens(tmtUST);
      setfees(ethers.utils.formatEther(tmtfee.toString()));
      setrcv_amount(Number(ethers.utils.formatEther(rcvAmountRaw.toString())));
      
      const parsedTokenAmount = ethers.utils.parseUnits(ethers.utils.formatEther(rcvAmountRaw.toString()), 18);
      // const allowance = await Usdtcontract.allowance(account, settings.contract);

      // if (allowance.lt(parsedAmount)) {
      //   const approv = await Usdtcontract.approve(settings.contract, parsedAmount);
      //   await approv.wait();
      //   toastSuccess("Token Approved");
      // }

      const tx = await Wcontract2.claim(parsedAmount, parsedTokenAmount);
      const receipt = await tx.wait();
      setHash(receipt.transactionHash);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "insert",
        user: account,
        hash: receipt.transactionHash,
        amt: amount,
        fee: fees,
        treceive: rcv_amount,
        token: total_tokens,
        rate: DefinRate,
        per: wfee,
        key: process.env.REACT_APP_KEY,
      });

      if (!res.data.error) {
        toastSuccess("Transaction done");
        setAmount(0);
        getsmcs();
      } else {
        toastError(res.data.error);
      }
    } catch (error) {
      toastError(`Transaction failed: ${error.message}`);
      fetchData();
    } finally {
      setTrdone(false);
      setLoading(false);
    }
  };

  useEffect(() => {
      getuserData()
    if (amount && rateContract) {
      fetchData();
      getsmcs();
    }
  }, [amount, useractivestatus, wfee, DefinRate, rateContract]);

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
        if (closeButton) closeButton.click();
      }, 1000);
    }
  }, [hash]);

  return (
    <div>
      <div className="modal fade" id="exampleModalCente2">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Claim</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={loading}></button>
            </div>
            <div className="modal-body">
              {settled === true ? "Your id is Settled." 
                :
                useractivestatus ? ("Restake Your Id First !") : (
                <>
                  {hash ? (
                    <div className="d-flex justify-content-center">
                      <img src="./assets/img/tr_done.gif" width={150} alt="done" />
                    </div>
                  ) : (
                    <>
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <label className="form-label text-black">Amount</label>
                          <label className="form-label text-black">
                            <span className="text-gray-500">Balance:</span> ${dbbalance}
                          </label>
                        </div>
                        <input
                          type="number"
                          className="form-control"
                          value={amount}
                          onChange={handleAmountChange}
                          placeholder="Enter Amount"
                          disabled={loading}
                        />
                      </div>
                      {errorMessage ? (
                        <div className="text-danger mt-2">{errorMessage}</div>
                      ) : (
                        <>
                          {amount && (
                            <div className="mt-3 text-center">
                              <p>
                                Fee 1% : ${total_tokens.toFixed(4)} ({fees} {process.env.REACT_APP_TOKEN_TICKER})
                              </p>
                              <h3 className="mb-0">
                                {rcv_amount} {process.env.REACT_APP_TOKEN_TICKER} (${RUsdt})
                              </h3>
                              <p className="mb-0">Received Amount</p>
                            </div>
                          )}
                        </>
                      )}
                      
                      
                      <div className="d-flex justify-content-center">
                        
                        {amount > 0 && amount < 30 && dbbalance > 0 && (
                          <button
                            type="button"
                            onClick={withdrawal}
                            className="btn btn-sm text-white bg-new-primary"
                            disabled={loading}
                          >
                            {loading ? "Processing..." : "Claim"}
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
              {loading && (
                <div className="d-flex justify-content-center mt-3">
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              )}
              {hash && (
                <div className="mt-3 text-center">
                  <h4>
                    <a
                      href={`${process.env.REACT_APP_EXPLORER}tx/${hash}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formatAddress(hash)}
                    </a>
                    &nbsp;<i className="fa fa-copy" onClick={() => copyaddress(hash)}></i>
                  </h4>
                  <p>Transaction Hash</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClaimModal;